import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle<{ theme?: Record<string, any> }>`
    * {
        margin: 0;
        padding: 0;
    }

    *, *::before, *::after {
        box-sizing: border-box;
    }

    html {
        width: 100%;
        height: 100%;
        font-size: 16px;
        font-family: 'Inter', -apple-system, 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
        -webkit-font-smoothing: antialiased;
    }

    body {
        width: 100%;
        height: 100%;
        color: ${p => (p.theme ? p.theme.palette.text.primary : 'black')};
        font-size: 1rem;
        font-weight: 500;
        background-color: ${p => (p.theme ? p.theme.customPalette.backgroundColor : 'white')};

        &.modal-lock {
            padding-right: 16px;
            overflow: hidden;
        }
    }

    #root {
        width: 100%;
        height: 100%;

        > div:first-child {
            height: inherit;
        }
    }
    
    a {
        text-decoration: none;
        transition: all .2s linear;
    }

    ul, ol {
        list-style: none;
    }
`;

export { GlobalStyles };
